import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import {Display3, Headline1} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './config.js'
import Financing from './Financing.js'
import PriceDropLabel from './PriceDropLabel.js'
import PriceIndicator from './PriceIndicator.js'

const Price = ({ad = {}, financingData, isPersonalLoanAvailable, onOpenDrawer}) => {
  const {i18n, domain} = useContext(Context)

  const {price, priceDrop} = ad

  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !domain.get('config').get('isMobile')
  })

  const CashPrice = isHigherThanMobile ? Display3 : Headline1

  return (
    <div className={BASE_CLASS}>
      <div className={`${BASE_CLASS}-cash`}>
        <div className={`${BASE_CLASS}-cashContent`}>
          <PriceDropLabel priceDrop={priceDrop} />
          <CashPrice as="p" className={`${BASE_CLASS}-cashValue`}>
            {i18n.c(price)}
          </CashPrice>
        </div>
        <PriceIndicator ad={ad} onOpenDrawer={onOpenDrawer} />
      </div>

      <Financing ad={ad} financingData={financingData} isPersonalLoanAvailable={isPersonalLoanAvailable} />
    </div>
  )
}

Price.displayName = 'Price'
Price.propTypes = {
  ad: PropTypes.object,
  financingData: PropTypes.shape({
    computedPrice: PropTypes.number,
    entry: PropTypes.number,
    fee: PropTypes.number,
    financedPrice: PropTypes.number,
    minEntry: PropTypes.number
  }),
  isPersonalLoanAvailable: PropTypes.bool,
  onOpenDrawer: PropTypes.func.isRequired
}

export default Price
